module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0117.jpg?v=1a067c8c";